module.exports = __webpack_public_path__ + "static/media/1.8f76d2ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Dots/1.svg
// module id = 305
// module chunks = 0